<modal-layout-middle2 (close)="close()">

    <ng-container ngProjectAs="[title]">Confirm Address</ng-container>

    <ng-container ngProjectAs="[content]">
        <radio-group class="block"
                     [name]="'address'"
                     [(ngModel)]="currentSelection">
            <div *ngFor="let address of addresses; let first = first"
                 class="m-t-5 b-a b-col-53">
                <radio [value]="address.id"
                       class="m-a-3">
                    <p class="s1 ">{{ checkoutAddressService.getMainLine(address.data) }}</p>
                    <p class="p2 m-t-3"
                       *ngFor="let line of checkoutAddressService.getAddressLines(address.data)">{{ line }}</p>
                </radio>
                <div *ngIf="!address.valid"
                     [ngSwitch]="isInvalid">
                    <div *ngSwitchCase="true"
                         class="col-2 p-t-2 p-b p-l p-r flex flex-top bg-col-53 w-12">
                        <i class="icon-faqs m-r-2"></i>
                        <p class="p2">We are unable to recognize your chosen shipping address, please check and try
                            again.
                        </p>
                    </div>
                    <div *ngSwitchCase="false"
                         class="col-2 p-t-2 p-b p-l p-r flex flex-top bg-col-53 w-12">
                        <i class="icon-faqs m-r-2"></i>
                        <p class="p2">We are unable to recognize your chosen shipping address, but we have found
                            recommendations below.
                        </p>
                    </div>
                </div>
            </div>
        </radio-group>

    </ng-container>

    <ng-container ngProjectAs="[bottom]">
        <ng-container [ngSwitch]="isInvalid">
            <button class="w-12 m-t-3 button"
                    *ngSwitchCase="true"
                    (click)="correct()">
                <span class="button__body">Edit This Address</span>
            </button>
            <button class="w-12 m-t-3 button-1"
                    *ngSwitchCase="true"
                    (click)="confirm()">
                <span class="button__body">Use This Address Anyway</span>
            </button>
            <button class="w-12 m-t-3 button"
                    *ngSwitchCase="false"
                    (click)="confirm()">
                <span class="button__body">Use This Address</span>
            </button>
        </ng-container>
    </ng-container>

</modal-layout-middle2>